export const schema = {
  type: "object",
  properties: {
    quicktextname: { type: "string" },
    relatedto: { type: "string" },
    field: { type: "string" },
    category: { type: "string" },
    message: { type: "string" },
  },
};
